import {
  RESET_AUTHENTICATION,
  SET_AUTHENTICATION,
  UPDATE_AUTHENTICATION,
} from 'store/types/authentication-types';

import { authenticationInitialState } from 'store/initial-states/authentication-initial-state';

export const authenticationReducer = (state = authenticationInitialState, action) => {
  switch (action.type) {
    case SET_AUTHENTICATION:
      return {
        ...state,
        ...action.payload,
      };

    case UPDATE_AUTHENTICATION:
      return {
        ...state,
        ...action.payload,
      };

    case RESET_AUTHENTICATION:
      return authenticationInitialState;

    default:
      return authenticationInitialState;
  }
};
